import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import { cloneValue, expectObject, readBoolean, splitKnown } from "../utils";

export class SpecsFabricColorCompatibilityModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    colorTendsToBleed: {
      label: "Color tends to bleed",
      fieldType: "boolean",
    },
    colorTendsToBeBledOn: {
      label: "Color tends to be bled on",
      fieldType: "boolean",
    },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  colorTendsToBleed!: boolean;
  colorTendsToBeBledOn!: boolean;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("colorTendsToBleed", false);
    this.defineObservableValue("colorTendsToBeBledOn", false);
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "fabric color compatibility");
    this.colorTendsToBleed = readBoolean(source, "colorTendsToBleed", false);
    this.colorTendsToBeBledOn = readBoolean(
      source,
      "colorTendsToBeBledOn",
      false
    );
    this.extra = splitKnown(source, [
      "colorTendsToBleed",
      "colorTendsToBeBledOn",
    ]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.colorTendsToBleed ? { colorTendsToBleed: true } : {}),
      ...(this.colorTendsToBeBledOn ? { colorTendsToBeBledOn: true } : {}),
    };
  }
}
